import repository from '@/utils/repository';

export default {
    searchCustomerInfo: (data) => {
        return repository.post(`/move/postCommonCustomerInfo`, {
            ...data
        });
    }
};
